const NAMESPACE = "editAttachmentCore";

const KEYS = {
    allowedAttachmentTypesLabel: "allowedAttachmentTypesLabel",
    allowLargeFilesLabel: "allowLargeFilesLabel",
    allowDocumentMergeLabel: "allowDocumentMergeLabel",
    isSensitiveLabel: "isSensitiveLabel",
    emptyAttachmentTypesText: "emptyAttachmentTypesText",
    blocklistedAttachmentTypesText: "blocklistedAttachmentTypesText",
    communicationUnsupportedAttachmentTypesText: "communicationUnsupportedAttachmentTypesText",
    mergeTypeUnsupportedAttachmentTypesText: "mergeTypeUnsupportedAttachmentTypes",
    allowsLargeAttachmentsESignatureEnvelopesText: "allowsLargeAttachmentsESignatureEnvelopesText",
    sensitiveAttachmentsIrreversibleText: "sensitiveAttachmentsIrreversibleText",
    sensitiveAttachmentsCommunicationsTemplatesText: "sensitiveAttachmentsCommunicationsTemplatesText",
    attachmentModalNote: "attachmentModalNote",
    referencingTemplateHeader: "referencingTemplateHeader",
    referencingEnvelopeHeader: "referencingEnvelopeHeader",
    noReferencesFoundPlaceholder: "noReferencesFoundPlaceholder",
    referenceDocumentExtensionsWarningText: "referenceDocumentExtensionsWarningText"
};

const MESSAGES = {
    [KEYS.allowedAttachmentTypesLabel]: {
        value: "Allowed File Extensions",
        comment: "Label for field that allows users to set allowed attachment extensions."
    },
    [KEYS.allowLargeFilesLabel]: {
        value: "Allow Large Files",
        comment: "Label for field that allows users to set if the attachment allows large files."
    },
    [KEYS.allowDocumentMergeLabel]: {
        value: "Allow Document Merge",
        comment:
            "Label for field that allows users to set if the attachment can be included in document merge templates."
    },
    [KEYS.isSensitiveLabel]: {
        value: "Is Sensitive",
        comment: "Label for field that allows users to set if the attachment field is sensitive data."
    },
    [KEYS.emptyAttachmentTypesText]: {
        value: "Allowed file types cannot be empty.",
        comment: "Text that appears when user has set allowed file types for the attachment."
    },
    [KEYS.blocklistedAttachmentTypesText]: {
        value: "File type(s) [{fileTypes}] not supported by PowerClerk.",
        comment: "Text that appears when user attempts to set attachment types that are unsupported by PowerClerk."
    },
    [KEYS.communicationUnsupportedAttachmentTypesText]: {
        value: "File type(s) [{fileTypes}] supported by PowerClerk, but not supported for use in communication templates.",
        comment:
            "Text that appears when user attempts to set attachment types that are unsupported in " +
            "communication templates."
    },
    [KEYS.mergeTypeUnsupportedAttachmentTypesText]: {
        value: "File type(s) [{fileTypes}] are not supported in merge templates and will be removed from allowed file extensions.",
        comment:
            "Text that appears when user attempts to set merge template attachment types " +
            "that are unsupported in merge templates."
    },
    [KEYS.allowsLargeAttachmentsESignatureEnvelopesText]: {
        value: "This attachment cannot be marked as Allows Large Files because it is referenced as an item by one or more eSignature Envelopes.",
        comment:
            "Text that appears when users fails to mark an attachment as allowsLarge because of the attachments presence on an eSignature Envelope"
    },
    [KEYS.sensitiveAttachmentsCommunicationsTemplatesText]: {
        value: "This attachment cannot be marked as sensitive because it's referenced by one or more communication templates.",
        comment:
            "Text that appears when user fails to mark an attachment as sensitive because of communication templates."
    },
    [KEYS.sensitiveAttachmentsIrreversibleText]: {
        value: "Marking an attachment as sensitive is irreversible. Once you click OK, this action cannot be undone.",
        comment: "Reminder text that appears when user intends to mark an attachment as sensitive."
    },
    [KEYS.attachmentModalNote]: {
        value: "NOTE: Any changes here will affect all forms where this attachment definition is used.",
        comment: "Note that making changes in the Edit Attachemnt modal will affect all uses of that attachment"
    },
    [KEYS.referencingTemplateHeader]: {
        value: "Referencing Communication Templates:",
        comment: "Header for the listed communication templates that reference this attachment"
    },
    [KEYS.referencingEnvelopeHeader]: {
        value: "Referencing eSignature Envelopes:",
        comment: "Header for the listed eSignature Envelopes that reference this attachment"
    },
    [KEYS.noReferencesFoundPlaceholder]: {
        value: "None",
        comment: "Placeholder text for when no references to this attachment are found"
    },
    [KEYS.referenceDocumentExtensionsWarningText]: {
        value: "The following file types support Attachment Validation: {fileTypes}. Files in other formats will not be validated. For PDF files, only single-page files will be validated.",
        comment: "Warning text that appears to warn user what file types support validation with reference documents."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
